import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import router from "@/router";
import settings from "@/settings";

Vue.use(Vuex);
let default_person_data = {
    id: null,
    first_name: null,
    last_name: null,
    birthday: null,
    group: null,
    special_needs: null,
    additional_info: null,
    phone: null,
    email: null,
    status: "active",
    avatar: {},
    avatar_url: null,
    facebook: null,
    age_group: null,
    removed: false,
    gender: null,
    parent_person_id: null,
    kids_count: null,
    kids: [],
    errors: [],
    events: [],
    all_events: []
};
let default_kid_data = {
    ...default_person_data,
    id: null,
    temp_id: null,
    age_group: "child",
    errors: []
};
export default {
    namespaced: true,
    state: {
        events_btn_disabled: true,
        show_save_btn: false,
        persons_events: [],
        event_ids: [],
        active_people_tab: "adults",
        person_save_btn_disabled: true,
        person_invite_btn_disabled: true,
        person_add_btn_disabled: true,
        person_save_btn_loading: false,
        errors: [],
        people: [],
        person_group_options: [
            { value: "friends", label: "Friends" },
            { value: "family", label: "Family" },
            { value: "work", label: "Work" },
            { value: "other", label: "Other" }
        ],
        person_gender_options: [
            { value: "woman", label: "Woman" },
            { value: "man", label: "Man" },
            { value: "none", label: "None" }
        ],
        person: JSON.parse(JSON.stringify(default_person_data)),
        kid: JSON.parse(JSON.stringify(default_kid_data))
    },
    getters: {
        adults: state => {
            if (state.people.length > 0) {
                return state.people.filter(item => {
                    return item.age_group === "adult";
                });
            } else {
                return [];
            }
        },
        kids: state => {
            if (state.people.length > 0) {
                return state.people.filter(item => {
                    return item.age_group === "child";
                });
            } else {
                return [];
            }
        },
        persons_kids: state => {
            if (state.person.kids.length > 0) {
                return state.person.kids.filter(item => {
                    return item.removed === false;
                });
            } else {
                return [];
            }
        }
    },
    mutations: {
        update_field(state, { prop_name, prop_value }) {
            state.person[prop_name] = prop_value;
            if (state.errors) {
                state.errors = state.errors.filter(item => item !== prop_name);
            }
        },
        set_btn_mode(state, val) {
            state.person_save_btn_disabled = !val;
        },
        set_invite_btn_mode(state, val) {
            state.person_invite_btn_disabled = val;
        },
        set_people_add_btn_mode(state, val) {
            state.person_add_btn_disabled = !val;
        },
        clear_errors(state) {
            state.errors = [];
        },
        set_save_btn_state(state, val) {
            state.show_save_btn = val;
        },
        set_person_btn_loading(state, boolean) {
            state.person_save_btn_loading = boolean;
        },
        set_person(state, person) {
            state.person = person;
        },
        set_kid_errors(state, { index, field }) {
            if (!state.person.kids[index].errors.includes(field)) {
                state.person.kids[index].errors.push(field);
            }
        },
        clear_kid_errors(state, { inx }) {
            state.person.kids[inx].errors = [];
        },
        set_person_kid(state, { index, prop_name, prop_value }) {
            if (state.person.kids[index].errors) {
                state.person.kids[index].errors = state.person.kids[index].errors.filter(item => item !== prop_name);
            }
            state.person.kids[index][prop_name] = prop_value;
        },
        remove_persons_kid(state, kid) {
            let index = state.person.kids.findIndex(_kid => _kid == kid);
            if (kid.id) {
                state.person.kids[index].removed = true;
            } else {
                state.person.kids.splice(index, 1);
            }
        },
        add_kid(state, kid) {
            state.person.kids.push(kid);
        },
        set_person_events(state, event_ids) {
            state.person.attended_events_ids = event_ids;
        },
        set_event_ids(state, event_ids) {
            state.event_ids = event_ids;
        },
        clear_person(state) {
            state.person = JSON.parse(JSON.stringify(default_person_data));
        },
        set_people_tab(state, tab) {
            state.active_people_tab = tab;
        },
        set_people(state, people) {
            Vue.nextTick(() => {
                state.people = people.splice(0);
            });
        },
        set_errors(state, errors) {
            state.errors = errors;
        },
        set_persons_events(state, data) {
            state.persons_events = data.events;
            if (data.count && data.count > 0) {
                state.events_btn_disabled = false;
            } else {
                state.events_btn_disabled = true;
            }
        }
    },

    actions: {
        async get_people({ commit }, sorted_by = false) {
            let data = {};
            if (sorted_by) {
                data = {
                    sorted_by: sorted_by
                };
            }
            try {
                let response = await axios.get(settings.api_url + "/people/", {
                    params: data
                });
                if (response && response.data && response.data.success === 1) {
                    let people_data = response.data.people;
                    commit("set_people", people_data);
                } else {
                    router.push({
                        path: "/error/"
                    });
                }
            } catch (error) {
                if (error.status === 401) {
                    router.push({ path: "/login" });
                } else {
                    router.push({
                        path: "/error/"
                    });
                }
            }
        },
        async get_person_events({ commit }, person_id) {
            let data = {
                person_id: person_id
            };
            try {
                let response = await axios.get(settings.api_url + "/person-events/", {
                    params: data
                });
                if (response && response.data) {
                    let events_data = response.data;
                    commit("set_persons_events", events_data);
                } else {
                    router.push({
                        path: "/error/"
                    });
                }
            } catch (error) {
                if (error.status === 401) {
                    router.push({ path: "/login" });
                } else {
                    router.push({
                        path: "/error/"
                    });
                }
            }
        },

        async get_person({ commit }, payload) {
            if (!payload) {
                return;
            }
            try {
                let response = await axios.get(settings.api_url + "/person/", {
                    params: {
                        person_id: payload
                    }
                });
                if (response && response.data) {
                    let person_data = response.data.person;
                    let person = {
                        id: person_data.id,
                        first_name: person_data.first_name ? person_data.first_name : null,
                        last_name: person_data.last_name ? person_data.last_name : null,
                        gender: person_data.gender ? person_data.gender : null,
                        group: person_data.group ? person_data.group : null,
                        facebook: person_data.facebook ? person_data.facebook : null,
                        email: person_data.email ? person_data.email : null,
                        birthday: person_data.birthday ? person_data.birthday : null,
                        phone: person_data.phone ? person_data.phone : null,
                        status: person_data.status ? person_data.status : "active",
                        avatar_url: person_data.avatar_url ? person_data.avatar_url : null,
                        additional_info: person_data.additional_info ? person_data.additional_info : null,
                        age_group: person_data.age_group ? person_data.age_group : null,
                        kids: person_data.kids ? person_data.kids : [],
                        events: person_data.events ? person_data.events : [],
                        all_events: person_data.all_events ? person_data.all_events : [],
                        removed: person_data.removed ? person_data.removed : false,
                        special_needs: person_data.special_needs ? person_data.special_needs : null
                    };
                    commit("set_person", person);
                }
            } catch (error) {
                console.log(error);
                if (error.status === 403) {
                    router.push({ path: "/people/" });
                }
            }
        },

        async save_person({ commit }, payload) {
            let errors = [];
            let data = payload;
            let valid = true;
            let fields_to_validate = ["first_name", "last_name"];

            if (payload["age_group"] === "child") {
                fields_to_validate = ["first_name"];
            }
            fields_to_validate.forEach(f => {
                if (!payload[f]) {
                    valid = false;
                    errors.push(f);
                }
            });
            if (payload["email"] && !window.validate_email(payload["email"])) {
                if (!errors.includes("email")) {
                    valid = false;
                    errors.push("email");
                }
            }

            commit("set_errors", errors);
            if (data["kids"]) {
                let kids_fields_to_validate = ["first_name"];
                data["kids"].forEach((kid, inx) => {
                    commit("clear_kid_errors", { inx });
                    kids_fields_to_validate.forEach(f => {
                        if (!kid[f]) {
                            valid = false;
                            commit("set_kid_errors", { index: inx, field: f });
                        }
                    });
                });
            }

            if (valid) {
                commit("set_person_btn_loading", true);

                try {
                    let response = await axios.post(settings.api_url + "/person/", data);
                    if (response && response.data) {
                        commit("set_person_btn_loading", false);
                        if (response.data.success === 1) {
                            router.push({
                                path: "/people/"
                            });
                            //window.location.reload();
                        } else {
                            router.push({
                                path: "/error/"
                            });
                        }
                    }
                } catch (error) {
                    commit("set_person_btn_loading", false);

                    if (error.data) {
                        router.push({
                            path: "/error/"
                        });
                    } else {
                        router.push({
                            path: "/error/connection-lost"
                        });
                    }
                }
            }
        },
        async delete_person({ commit }, payload) {
            let errors = [];
            commit("set_errors", errors);
            if (errors.length === 0) {
                try {
                    let response = await axios.delete(settings.api_url + "/person/?id=" + payload);
                    if (response && response.data) {
                        if (response.data.success === 1) {
                            router.push({
                                path: "/people/"
                            });
                        } else {
                            router.push({
                                path: "/people/"
                            });
                        }
                    }
                } catch (error) {
                    if (error.data) {
                        router.push({
                            path: "/error/"
                        });
                    } else {
                        router.push({
                            path: "/error/connection-lost"
                        });
                    }
                }
            }
        },
        async invite_to_events({ commit }, payload) {
            let errors = [];
            let data = {
                event_ids: this.state.StorePeople.event_ids,
                person_id: this.state.StorePeople.person.id,
                action: "invite_person_to_events"
            };
            commit("set_errors", errors);
            if (errors.length === 0) {
                try {
                    let response = await axios.post(settings.api_url + "/person/", data);
                    if (response && response.data) {
                        commit("set_event_ids", []);

                        if (response.data.success === 1) {
                            router.push({
                                path: "/people/" + this.state.StorePeople.person.id
                            });
                        } else {
                            router.push({
                                path: "/error/"
                            });
                        }
                    }
                } catch (error) {
                    if (error.data) {
                        router.push({
                            path: "/error/"
                        });
                    } else {
                        router.push({
                            path: "/error/connection-lost"
                        });
                    }
                }
            }
        },
        async upload_person_logo({ commit }, payload) {
            let errors = [];
            commit("set_errors", errors);
            let data = new FormData();
            data.append("avatar_logo", payload.file);
            data.append("name", "avatar_logo");
            const conf = {
                headers: { "content-type": "multipart/form-data" }
            };
            if (errors.length === 0) {
                try {
                    let response = await axios.post(
                        settings.api_url + "/persons/" + payload.person_id + "/upload-avatar",
                        data,
                        conf
                    );
                    if (response && response.data) {
                        if (response.data.success === 1) {
                            commit("update_field", {
                                prop_name: "avatar_url",
                                prop_value: response.data.avatar_url
                            });
                        } else {
                        }
                    }
                } catch (error) {
                    return;
                    if (error.data) {
                        router.push({
                            path: "/error/"
                        });
                    } else {
                        router.push({
                            path: "/error/connection-lost"
                        });
                    }
                }
            }
        }
    }
};
